<template>
    <div>
      <div class="bg-color-red userform_top"></div>
      <div class="userform">
        <h3 class="userform_title">分销申请信息</h3>
        <div v-if="applyInfo.status == -3 || applyInfo.status==-1">
            <h5 style="margin-bottom: 10px;" v-if="applyInfo.status == -1">
                <p style="color: red;">
                    {{ applyInfo.msg }}，请重新填写表单
                </p>
                <div>
                    <div style="line-height: 2;">原因：</div>            
                    <textarea
                        style="width: 100%;background-color: #fafafa;padding: 10px;"    
                        v-model="applyInfo.no_pass_msg"
                        placeholder=""
                        disabled />
                </div>
            </h5>
            <div class="tips"><span>*&nbsp;</span>平台</div>
            <van-radio-group v-model="formInfo.mail">
                <div class="radio-list-box">
                    <div class="radio-item" v-for="(item,index) in radioList" :key="index">
                        <van-radio :name="item">{{ item }}</van-radio>
                    </div>
                </div>
            </van-radio-group>
            <h4>注意:平台订单号和平台订单截图可填写任意一项</h4>
            <div class="tips"><span>*&nbsp;</span>平台订单号</div>
            <div class="userform_item">
              <input type="text" placeholder="" v-model="formInfo.order_number"/>
            </div>
            <div class="uploader_form">
              <div class="tips"><span>*&nbsp;</span>平台订单截图</div>
                <div class="upload acea-row row-middle">
                <div
                  class="pictrue"
                  v-for="(img, index) in formInfo.order_image"
                  :key="img"
                >
                  <img :src="img" />
                  <div
                    class="iconfont icon-guanbi1 font-color-red"
                    @click="formInfo.order_image.splice(index, 1)"
                  ></div>
                </div>
                <VueCoreImageUpload
                  class="btn btn-primary"
                  :crop="false"
                  compress="80"
                  @imageuploaded="imageuploaded"
                  :headers="headers"
                  :max-file-size="5242880"
                  :credentials="false"
                  inputAccept="image/*"
                  inputOfFile="file"
                  :url="url"
                  v-if="formInfo.order_image.length < 1"
                >
                  <div class="pictrue acea-row row-center-wrapper row-column">
                    <span class="iconfont icon-icon25201"></span>
                    <div>上传照片</div>
                  </div>
                </VueCoreImageUpload>
            </div>  
            </div>
            <button class="userform_submit bg-color-red" @click="userformsubmit()">
              提交申请
            </button>
        </div>
        <div class="" v-else>
            <h5 v-if="applyInfo.status!=-2">申请时间：{{ applyInfo.apply_time }}</h5>
            <h5>状态：{{ applyInfo.msg }}</h5>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  import {
    userform,
    distributionApply,
    checkDistributionApply
  } from "@api/user";
  import { VUE_APP_API_URL } from "@utils";
  import VueCoreImageUpload from "vue-core-image-upload";

  import Radio from 'vant/lib/radio';
  import 'vant/lib/radio/style';
  import RadioGroup from 'vant/lib/radio-group';
  import 'vant/lib/radio-group/style';
  
  export default {
    name:"DistributionApply",
    components:{
      VueCoreImageUpload,
      [Radio.name]:Radio,
      [RadioGroup.name]:RadioGroup,
    },
    data: function() {
      return {
        radio:'1',
        // 图片上传
        url: `${VUE_APP_API_URL}/upload/image`,
        headers: {
          "Authori-zation": "Bearer " + this.$store.state.app.token
        },
        formInfo:{
            mail:'天猫',
            order_number:'',
            order_image:[]
        },
        radioList:['天猫','京东','拼多多','小红书','抖音','淘宝'],
        applyInfo:{}
    }
    },
    watch:{},
    mounted() {
        this.getApplyInfo()
    },
    methods: {
      imageuploaded(res) {
        if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
            this.formInfo.order_image.push(res.data.url);
        },

      // 获取申请信息
      getApplyInfo(){
        checkDistributionApply().then(res=>{
            this.applyInfo = res.data
        })
      },   
      
      //提交申请   
      async userformsubmit() {
        console.log(this.formInfo);
        
        let that = this
        if (this.formInfo.order_image.length > 0 || this.formInfo.order_number ) {
            console.log('信息填写完成');
        }else{            
            this.$dialog.message("请填写平台订单号或者订单截图！")
            return;
        }
        distributionApply(this.formInfo).then(res => {
            this.$dialog.message(res.msg);
            this.$router.go(0);
          })
          .catch(res => {
            if (res.data.status === 402) {
              this.$dialog.error(res.msg);
            }else if (res.data.status === 400) {
              this.$dialog.error(res.msg);
            }
            this.$dialog.error(res.msg);
          });
        }
      },
    }
  </script>
  
  <style scoped>

  .radio-list-box{
    display: flex;
    flex-wrap: wrap;
  }
  .radio-item{
    margin: 0.2rem  0.05rem
  }
  h4{
    font-size: 12px;
    padding: 0.35rem 0;
    color: red;
  }
 
  .uploader_form{ margin-bottom: 1.6em;}
  .uploader_form .upload .pictrue{margin-right:.22rem;width:1.56rem;height:1.56rem;position:relative;font-size:0.24rem;color:#bbb;border:1px solid #bbb}
  .uploader_form .upload .pictrue img{width:100%;height:100%}
  .uploader_form .upload .pictrue .icon-guanbi1{position:absolute;font-size:0.45rem;top:-0.1rem;right:-0.1rem;width:0.45rem;height:0.45rem;line-height:0.45rem}
  .userform_top{width:100%;height:150px;position:absolute;top:0;left:0;z-index:999;background:linear-gradient(0deg,#434343,#000000);background:-webkit-linear-gradient(0deg,#434343,#000000);background:-moz-linear-gradient(0deg,#434343,#000000);background:-ms-linear-gradient(0deg,#434343,#000000)}
  .userform{font-size:15px;box-sizing:border-box;border-radius:0.8em;padding:1.6em;width:85%;margin:50px auto 0;background:#ffffff;box-shadow:2px 2px 16px 0 rgba(0,0,0,0.08);color:#000;position:relative;z-index:1000}
  .userform .userform_title{text-align:center;font-size:20px;padding-bottom:1.2em}
  .userform .userform_item{width:100%;margin:0 auto;margin-bottom:1.6em;display:flex;justify-content:space-between;align-items:center;position:relative}
  .userform .userform_item_red:before{content:"*";display:block;padding:0 0.4em;color:rgb(223,53,53);position:absolute}
  .userform .userform_item .yzm{width:7.6em;padding:0 0.6em;background:#80cdd4;color:#ffffff;margin-left:0.6em;line-height:2.4em;text-align:center}
  .userform .userform_item_agent{border-bottom:1px solid #80cdd4;color:#80cdd4}
  .userform  .userform_item_agent .agent_level_info{width:100%;display:flex;justify-content:space-between;line-height:2.4em;padding-left:1.2em}
  .userform .userform_item_agent .agent_level_child{box-sizing:border-box;width:100%;position:absolute;top:2.4em;z-index:1000;color:#000;background:#ffffff;box-shadow:0 2px 12px 0 rgba(0,0,0,0.1);line-height:2em;padding:1em;border-radius:0 0 4px 4px;border-top:1px solid #80cdd4}
  .userform .userform_item_agent .agent_level_name span{display:inline-block;color:#80cdd4;font-weight:600;margin-right:0.3em}
  .userform .userform_item .yzm.actived{background:#f2f2f2;color:#999999}
  .userform .userform_item .yzm_number{width:8em;text-align:center;letter-spacing:1px}
  .userform .userform_item .agentcode{width:10.6em;text-align:center;color:#000;margin-right:0.4em}
  .userform .userform_item input,.userform .userform_item textarea{width:100%;display:block;background:#f5f5f5;border-radius:4px;color:#000;line-height:1.6em;padding:0.6em 0.6em}
  .userform .userform_item input{line-height:2.4em;padding:0 1em}
  .userform .userform_item_textarea.userform_item{align-items:flex-start}
  .userform .userform_item_bottom{display:flex}
  .userform .userform_item .userform_agreement{display:flex}
  .userform .userform_item .userform_agreement span{color:#80cdd4}
  .userform_item_label{font-size:12px;color:rgb(255,70,70);position:absolute;left:0;bottom:-2em;z-index:1000;text-indent:1em;line-height:2em;text-align:left}
  .userform_submit{margin:0 auto;display:block;width:80%;line-height:2.4em;border-radius:1.2em;background:linear-gradient(90deg,#80cdd4,#80cdd4);background:-webkit-linear-gradient(90deg,#80cdd4,#80cdd4);background:-moz-linear-gradient(90deg,#80cdd4,#80cdd4);background:-ms-linear-gradient(90deg,#80cdd4,#80cdd4);text-align:center;font-weight:600;color:#452f0d}
  .userform_description{width:90%;margin:0 auto;font-size:14px;padding-top:2em;line-height:1.6em;color:#80cdd4}
  .userform_description p{font-size:1.2em;display:inline-block;font-weight:600}
  .tips{font-size:.3rem;color:#848484;margin-bottom:.2rem}
  .tips span{color:rgb(223,53,53)}
  .agreement{display:flex;margin-bottom:1.6em}
  .agreement .agreement-details{color:#9dccd0}
  .van-popup.van-popup--center{border-radius:10px}
  .agreement-article{width:80vw;height:80vh;padding:.5rem .4rem .4rem;border-radius:10px}
  .agreement-article .title{font-size:.48rem;font-weight:700;margin-bottom:.3rem}
  
  
  .criterion-wrap .opation{display: flex;justify-content: space-between;padding: .2rem .3rem;border-bottom: 1px solid #f0f0f0;}
  .criterion-wrap .opation .cancel,.criterion-wrap .opation .confirm{font-size: .32rem;color: #2c92d7;}
  .criterion-wrap .opation .desc{font-size: .32rem;color: #000;font-weight: 600;}
  .criterion-wrap .criterion-list{white-space: nowrap;overflow-x: scroll;margin:.54rem 0; scrollbar-width: none;-ms-overflow-style: none;}
  .criterion-wrap .criterion-list::-webkit-scrollbar{display: none;}
  .criterion-wrap .criterion-list .criterion-item:first-of-type{margin-left: .5rem;}
  .criterion-wrap .criterion-list .criterion-item{display: inline-block;width: 4.5rem;height: 4.8rem;white-space: normal;padding: .32rem .28rem;border: 1px solid #e1e1e1;border-radius: 10px;vertical-align: bottom;margin-right: .4rem;}
  .criterion-wrap .criterion-list .criterion-item.on{border-color: #cea85f;background: rgb(206, 168, 95,.12);}
  .criterion-list .criterion-item .criterion-item-wrap{display: flex;flex-wrap: wrap;height: 100%;align-content: space-between;}
  .criterion-list .criterion-item .text{font-size: .3rem;color: #333;font-weight: 700;text-align: justify;}
  .criterion-list .criterion-item .remarks{font-size: .28rem;color: #a7a7a7;text-align: justify;margin-top: .16rem;}
  .criterion-list .criterion-item .pay{width:100%;text-align: right;font-size: .48rem;color: #cea85f;font-weight: 500;line-height: 1;}
  .criterion-list .criterion-item .pay img{width: .36rem;vertical-align: bottom;}
  </style>
  <style>
  .agreement-content *{word-break:break-all}
  </style>
  